import { render, staticRenderFns } from "./MedicationsPage.vue?vue&type=template&id=642fad5c&"
import script from "./MedicationsPage.vue?vue&type=script&lang=js&"
export * from "./MedicationsPage.vue?vue&type=script&lang=js&"
import style0 from "./MedicationsPage.vue?vue&type=style&index=0&id=642fad5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports